import * as React from 'react';
import { Checkbox, Col, FormGroup, Row } from 'react-bootstrap';
import { IEditProduct } from "../../Types";

type StatusSectionLabels = {
    status: string;
    isDiscontinued: string;
    isVisibleToCustomer: string;
    isPhotographerProduct: string;
    isPhotographerPreChosen: string;
    isPossibleToSplitFromOrder: string;
    uploadable: string;
    isStylingProduct: string;
};

type StatusSectionProps = {
    labels: StatusSectionLabels;
    product: IEditProduct;
    onAnyChange: (event: React.ChangeEvent<Checkbox>) => void;
};

export function StatusSection({ labels, product, onAnyChange }: StatusSectionProps) {
    return (
        <fieldset>
            <legend>{labels.status}</legend>
            <Row>
                <Col md={6}>
                    <FormGroup>
                        <Checkbox
                            name="isDiscontinued"
                            disabled={product.isSystem}
                            checked={product.isDiscontinued ? product.isDiscontinued : false}
                            onChange={onAnyChange}
                        >
                            <span>{labels.isDiscontinued}</span>
                        </Checkbox>
                        <Checkbox
                            name="isVisibleToCustomer"
                            disabled={product.isSystem}
                            checked={
                                product.isVisibleToCustomer ? product.isVisibleToCustomer : false
                            }
                            onChange={onAnyChange}
                        >
                            <span>{labels.isVisibleToCustomer}</span>
                        </Checkbox>
                        <Checkbox
                            name="isPhotographerProduct"
                            disabled={product.isSystem}
                            checked={
                                product.isPhotographerProduct
                                    ? product.isPhotographerProduct
                                    : false
                            }
                            onChange={onAnyChange}
                        >
                            <span>{labels.isPhotographerProduct}</span>
                        </Checkbox>
                        <Checkbox
                          name="isPhotographerProductPreChoosen"
                          disabled={product.isSystem}
                          checked={
                              product.isPhotographerProductPreChoosen
                                ? product.isPhotographerProductPreChoosen
                                : false
                          }
                          onChange={onAnyChange}
                        >
                            <span>{labels.isPhotographerPreChosen}</span>
                        </Checkbox>
                    </FormGroup>
                </Col>
                <Col md={6}>
                    <FormGroup>
                        <Checkbox
                            name="isUploadable"
                            disabled={product.isSystem}
                            checked={product.isUploadable ? product.isUploadable : false}
                            onChange={onAnyChange}
                        >
                            <span>{labels.uploadable}</span>
                        </Checkbox>
                        <Checkbox
                            name="isStylingProduct"
                            disabled={product.isSystem}
                            checked={product.isStylingProduct ? product.isStylingProduct : false}
                            onChange={onAnyChange}
                        >
                            <span>{labels.isStylingProduct}</span>
                        </Checkbox>
                        <Checkbox
                          name="isPossibleToSplitFromOrder"
                          disabled={product.isSystem}
                          checked={
                              product.isPossibleToSplitFromOrder
                                ? product.isPossibleToSplitFromOrder
                                : false
                          }
                          onChange={onAnyChange}
                        >
                            <span>{labels.isPossibleToSplitFromOrder}</span>
                        </Checkbox>
                    </FormGroup>
                </Col>
            </Row>
        </fieldset>
    );
}
